import { Step } from 'react-joyride';

// Territories page controlled tour steps
export const territoriesSteps: Step[] = [
  {
    target: '.territories-page-header',
    title: 'Welcome to Territories',
    content:
      'This is your territory explorer where you can discover, explore, and manage available franchise territories.',
    placement: 'bottom',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
  {
    target: '.territories-map-container',
    title: 'Interactive Territory Map',
    content:
      'Explore territories visually on this interactive map. You can zoom, pan, and click on territories to see details.',
    placement: 'bottom',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
  {
    target: '.map-expand-button',
    title: 'Expand Map View',
    content:
      'Click this button to expand the map for a better view. Try clicking it now!',
    placement: 'left',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
  {
    target: '.territories-search-input',
    title: 'Search Territories',
    content:
      'Use this search to filter territories by state name or zip code. Try searching for a state!',
    placement: 'bottom',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: '.territories-by-state-container',
    title: 'Territories by State',
    content:
      'Browse territories organized by state. Each state shows the total, sold, and reserved territory counts.',
    placement: 'top',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: '.state-view-button',
    title: 'View State Territories',
    content:
      'Click "View" to expand a state and see all its territories. Try expanding a state now!',
    placement: 'left',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
  {
    target: '.territory-item-row',
    title: 'Individual Territories',
    content:
      'Each territory shows its ID, zip codes, current status, and assigned candidate information.',
    placement: 'top',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
  {
    target: '.territory-expand-button',
    title: 'Territory Details',
    content:
      'Click this button to see detailed demographics and candidate information for this territory.',
    placement: 'left',
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: true,
  },
];
